import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import hero from "../../../images/hero.png";
import "./Hero.css";
import first from "../../../images/middle-left.png";
import second from "../../../images/top-left.png";
import third from "../../../images/top-right.png";
import fourth from "../../../images/middle-right.png";
import fifth from "../../../images/bottom-left.png";
import sixth from "../../../images/bottom-right.png";

const words = ["парню", "другу", "мужчине", "папе", "брату"];
function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1750);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">
      <div className="container">
        <div className="hero__container">
          <div className="hero__content">
            <h1 className="hero__title">
              сделай намек <br /> своему{" "}
              <span
                className="hero__span"
                style={{
                  display: "inline-block",
                  position: "relative",
                  height: "1.05em",
                  minWidth: "150px", // So‘zlar uchun yetarli eni
                  backgroundColor: "#fff", // Mana shu fon doim oq bo‘ladi
                  textAlign: "center", // So‘zlar markazda
                  borderRadius: "5px", // Optional
                  padding: "0 6px",
                  top: "0.25em",
                  paddingTop: "2px",
                  lineHeight: "0.9em",
                  // bottom: "0.25em",
                }}
              >
                <AnimatePresence mode="wait">
                  <motion.span
                    className="hero__span-content"
                    key={words[index]}
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 20, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    style={{
                      display: "inline-block",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      width: "100%",
                      textAlign: "center",
                      transform: "translateY(-20%)",
                    }}
                  >
                    {words[index]}
                  </motion.span>
                </AnimatePresence>
              </span>{" "}
              <br />и получи.. <br /> букетик от него 💝
            </h1>
          </div>

          <ul className="hero__list">
            <li className="hero__item">
              <img className="hero__item-img" src={first} alt="first" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={second} alt="second" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={third} alt="third" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={fourth} alt="fourth" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={fifth} alt="fifth" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={sixth} alt="sixth" />
            </li>
          </ul>
        </div>
      </div>

      <img src={hero} className="hero__img" alt="Hero" />
    </div>
  );
}

export default Hero;
